import {ValueObject} from '@s-ui/domain'

import {NumberSharedValueObject} from '../../shared/ValueObjects/NumberSharedValueObject.js'

export class FilterRangeSearchValueObject extends ValueObject {
  #from
  #to

  constructor({from, to}) {
    super()
    this.#from = from
    this.#to = to
  }

  static create({from, to}) {
    return new FilterRangeSearchValueObject({
      from: NumberSharedValueObject.create({value: from}),
      to: NumberSharedValueObject.create({value: to})
    })
  }

  get from() {
    return this.#from.value
  }

  get to() {
    return this.#to.value
  }

  get isEmpty() {
    return this.#from.isEmpty && this.#to.isEmpty
  }

  get value() {
    return {from: this.#from.value, to: this.#to.value}
  }

  toJSON() {
    return {
      from: this.#from.toJSON(),
      to: this.#to.toJSON()
    }
  }
}
